/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Jd_AnalysisInputs */

const en_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JD analysis`)
};

const de_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JD-Analyse`)
};

const fr_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse de la description de poste`)
};

const es_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de descripción de puesto`)
};

const it_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi JD`)
};

const nl_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JD-analyse`)
};

const pl_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza JD`)
};

const fi_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JD-analyysi`)
};

const da_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbeskrivelsesanalyse`)
};

const sv_pricing_feature_jd_analysis = /** @type {(inputs: Pricing_Feature_Jd_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JD-analys`)
};

/**
* | output |
* | --- |
* | "JD analysis" |
*
* @param {Pricing_Feature_Jd_AnalysisInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_jd_analysis = /** @type {((inputs?: Pricing_Feature_Jd_AnalysisInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Jd_AnalysisInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_jd_analysis(inputs)
	if (locale === "fr") return fr_pricing_feature_jd_analysis(inputs)
	if (locale === "es") return es_pricing_feature_jd_analysis(inputs)
	if (locale === "it") return it_pricing_feature_jd_analysis(inputs)
	if (locale === "nl") return nl_pricing_feature_jd_analysis(inputs)
	if (locale === "pl") return pl_pricing_feature_jd_analysis(inputs)
	if (locale === "fi") return fi_pricing_feature_jd_analysis(inputs)
	if (locale === "da") return da_pricing_feature_jd_analysis(inputs)
	if (locale === "sv") return sv_pricing_feature_jd_analysis(inputs)
	return en_pricing_feature_jd_analysis(inputs)
});